import { Component, ElementRef, HostListener, OnDestroy, OnInit, QueryList, ViewChildren, ChangeDetectorRef} from '@angular/core';
import { FormControl } from '@angular/forms';
import { ModalDismissReasons, NgbModal, NgbModalConfig, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { CurrentLanguage } from 'projects/Autofacets-Core/src/app/common-services/current-language.service';
import { GlobalSetting } from 'projects/Autofacets-Core/src/app/common-services/global-setting.service';
import { SecureStorage } from 'projects/Autofacets-Core/src/app/common-services/SecureStorage.service';
import { NgbdModalContent } from 'projects/Autofacets-Core/src/app/shared/delete-modal.component';
import { NgInfoModalContent } from 'projects/Autofacets-Core/src/app/shared/info-modal.component';
import { Constant } from 'projects/Autofacets-Core/src/app/utils/constant';
import { Utility } from 'projects/Autofacets-Core/src/app/utils/utility';
import { Observable, Subscription } from 'rxjs';
import { UserDataService } from 'src/app/DataServices/user-data.service';
import { ApplicationSource} from '../../business-entities/application-source';
import { BrandViewModel } from '../../business-entities/brand-view-model';
import { DMSSyncFailedLogRequestModel } from '../../business-entities/dmssyncfailedlog-request-model';
import { Filter } from '../../business-entities/Filter';
import { FuelType, VehicleStatusModel } from '../../business-entities/fuel-view-model';
import { PagerData } from '../../business-entities/PagerData';
import { DeleteAdvanceSearchFilterModel, SaveAdvanceSearchFilterModel, SearchArrayModel } from '../../business-entities/save-advance-search-filter';
import { StatusViewModel } from '../../business-entities/status-view-model';
import { UserRoleMenu } from '../../business-entities/user-role-menu.model';
import { BrandType, VehicleListViewModel, VehicleTransmission,VehicleType } from '../../business-entities/vehicle-list-view-model';
import { AdvanceSearchService } from '../../business-services/advance-search.service';
import { ApplicationSourceService } from '../../business-services/application-source.service';
import { BrandService } from '../../business-services/brand.service';
import { CheckListBusinessService } from '../../business-services/check-list.service';
import { DashboardService } from '../../business-services/dashboard.service';
import { DMSSyncFailedlogService } from '../../business-services/dms-sync-failed-log.service';
import { EditAppointmentService } from '../../business-services/edit-appointment.service';
import { RentalCarService } from '../../business-services/rental-car.service';
import { SavedSearchComponent } from '../../components/saved-search/saved-search.component';
import { PaginationService } from '../../services/pagination.service';
import { NgbdSortableHeader, SortEvent} from './../../../../../Autofacets-Core/src/app/directives/sortable.directive';
import * as Enums from './../../../../../Autofacets-Core/src/app/utils/enums';
import { VehicleBusinessService } from './../../business-services/vehicle-service';
import { EditVehicleComponent } from './edit-vehicle/edit-vehicle.component';
import { MultiStackPopupService } from '../../services/multi-stack-popup.service';

@Component({
  selector: 'app-vehicle-management',
  templateUrl: './vehicle-management.component.html',
  styleUrls: ['./vehicle-management.component.css'],
})
export class VehicleManagementComponent implements OnInit, OnDestroy {
  isAdvanceSearch: any;
  vehicleStatusList: VehicleStatusModel[] = [];
  vehicleTypes: VehicleType[] = [];
  makeList: BrandType[] = [];
  vehicleList: VehicleListViewModel[];
  applicationSourceList: ApplicationSource[] = [];
  fuels: FuelType[] = [];
  vehicleTransmissionList: VehicleTransmission[] = [];
  saveSearchFilter: SaveAdvanceSearchFilterModel = {
    filterName: null,
    moduleId: Enums.ModuleNames.Vehicle,
    saveSearchArray: []
  };
  deleteSearchFilter: DeleteAdvanceSearchFilterModel = {
    filterName: null,
    moduleId: Enums.ModuleNames.Vehicle,
  };
  savedSearchListResponse: SaveAdvanceSearchFilterModel[] = [];
  total$: Observable<number>;
  paginationSub: Subscription;
  subscription : Subscription;
  userRoleRightsDetails: UserRoleMenu;
  brandList: BrandViewModel[];
  licensePlateClass: string;
  popupCloseResult = false;
  closeResult: string;
  selectedSync: number;
  control = new FormControl();
  pager: any = {};
  totalCount: number = 0;
  pagerData: PagerData = {
    page: 1,
    pagerSize: 25//Constant.GridPagerSize,
  };
  dataRows: any[] = [];
  filter: Filter = new Filter();
  filterItems: any[];
  pagedItems: any[];
  searchTerm: string = '';
  integrationWithDMS: boolean = false;
  SyncList: StatusViewModel[] = [];
  endDate: string;
  changeRowColor: boolean;
  isMG: boolean;
  dmsLogRequestModel: DMSSyncFailedLogRequestModel =
  {
    startRecordNumber: 0,
    pageSize: 25,
    sortColumn: '',
    sortDirection: '',
    moduleId: Enums.ModuleNames.Vehicle,
    logDate: '',
    referenceId: 0
  };
  debounceTimer;
  @ViewChildren(NgbdSortableHeader) headers: QueryList<NgbdSortableHeader>;

  throttle = 100;
  scrollDistance = 1;
  _clientName: string;

  constructor(
    private service: VehicleBusinessService,
    private spinner: NgxSpinnerService,
    private editAppointmentService: EditAppointmentService,
    private brandService: BrandService,
    private userService: UserDataService,
    private globalSetting: GlobalSetting,
    private modalService: NgbModal,
    private pagerService: PaginationService,
    private checkListService: CheckListBusinessService,
    private toaster: ToastrService,
    private translate: TranslateService,
    private secureStorage: SecureStorage,
    private EditRentalCar: RentalCarService,
    private applicationSourceService: ApplicationSourceService,
    private transmissionService: VehicleBusinessService,
    private advanceSearchService: AdvanceSearchService,
    private dashboardService: DashboardService,
    private dmsService: DMSSyncFailedlogService,
    private _eref: ElementRef,
    private activeModal: NgbActiveModal,
    private cdr: ChangeDetectorRef,
    private currentLanguageService: CurrentLanguage,
    private multiStackPopupService: MultiStackPopupService,
    config: NgbModalConfig
  ) {
    config.backdrop = 'static';
    config.keyboard = false;
  }

  ngOnInit() {
    this._clientName = localStorage.getItem("Theme");
    this.changeRowColor = this._clientName === 'bnh';
    this.isMG = this._clientName === 'mg';
    this.endDate = Utility.GetFormattedDate(new Date());
    this.SyncList = this.dashboardService.getDmsStatusList();
    this.service.vehicleListRequest.startRecordNumber = 0;
    this.vehicleList = []
    this.applicationSourceService.getFeatures();
    if (this._clientName === 'mg') {
      this.getFeatures();
    }
    this.getBrands().then(()=>{
      this.getVehicleList();
    });
    this.licensePlateClass = this.globalSetting.getGlobalLicencePlate();
    this.userRoleRightsDetails = (
      this.userService.currentUserValue.userRoleMenuDetails as any[]
    ).find((menu) => menu.moduleId === Enums.ModuleNames.Vehicle);
    this.vehicleList = [];
    this.service.vehicleListRequest.syncId = Enums.DmsSync.All;
    this.RemoveFilter();
  }

  onRefresh() {
    this.vehicleList = [];
    this.service.vehicleListRequest.startRecordNumber = 0;
    this.getVehicleList();
  }

  RemoveFilter() {
    const VehicleListRequestModel =
    {
      searchTerm: '',
      startRecordNumber: 0,
      pageSize: 25,
      sortColumn: '',
      sortDirection: '',
      isForDocuments: false,
      licensePlate: '',
      companyMakeName: null,
      registrationDate: '',
      color: '',
      year: null,
      chassisNo: '',
      fuelType: null,
      sourceOfCreation: null,
      vehicleType: null,
      vehicleGroup: null,
      transmission: null,
      syncId: 0
    }
    this.service.vehicleListRequest = VehicleListRequestModel;
  }

  async GetAllVehicleStatus(): Promise<void> {
    await this.EditRentalCar.GetAllVehicleStatus().then(data => {
      this.vehicleStatusList = data.responseObject.result.slice();
    });
  }

  async GetAllVehicleTypes(): Promise<void> {
    await this.checkListService.getVehicleTypes().then(data => {
        this.vehicleTypes = data.responseObject.filter(x => x.isDisplay);
    });
  }

  async GetAllMake(): Promise<void> {
    await this.brandService.GetBrandDropdown().then(data => {
      this.makeList = data.responseObject;
    });
  }

  async GetApplicationSource(): Promise<void> {
    await this.applicationSourceService.getApplicationSource().then(data => {
      this.applicationSourceList = data.responseObject;
      this.applicationSourceList = this.applicationSourceList.filter(source => this.isMG ? (source.sourceName === 'Planner' || source.sourceName === 'OLB' || source.sourceName === 'CRM') : source.sourceName != 'Dwo');
    });
  }

  async GetAllFuelTypes(): Promise<void> {
    await this.EditRentalCar.GetFuelTypes().then(data => {
      this.fuels = data.responseObject.result.slice();
    });
  }

  async GetVehicleTransmission(): Promise<void> {
    await this.transmissionService.GetVehicleTransmissionDropdownList().then(data => {
      this.vehicleTransmissionList = data.responseObject;
    });
  }

  isDigit(event): void {
    const isDigit = Utility.isDigit(event);
    if (!isDigit) {
      event.preventDefault();
    }
  }

  
  ngOnDestroy(): void {
    if (this.paginationSub) {
      this.paginationSub.unsubscribe();
    }
    if(this.subscription){
      this.subscription.unsubscribe();
    }
  }

  onSort({ column, direction }: SortEvent) {
    this.headers.forEach((header) => {
      if (header.sortable !== column) {
        header.direction = '';
      }
    });
    this.service.vehicleListRequest.sortColumn = column;
    this.service.vehicleListRequest.sortDirection = direction;
    this.service.vehicleListRequest.searchTerm = null
    this.vehicleList = [];
    this.service.vehicleListRequest.startRecordNumber = 0;
    this.getVehicleList();
  }
  onEnterPress(){
    this.debounceFunction(()=>this.onSearchFilter(),500);
  }

  debounceFunction(func,delay){
    window.clearTimeout(this.debounceTimer);
    this.debounceTimer = window.setTimeout(func, delay);
  }
  onSearchFilter() {
    this.vehicleList = [];
    this.service.vehicleListRequest.startRecordNumber = 0;
    this.service.vehicleListRequest.searchTerm = this.searchTerm;
    this.getVehicleList();
  }

  onReset() {
    this.resetVariables();
    this.getVehicleList();
  }
  resetVariables() {
    this.vehicleList = [];
    this.service.vehicleListRequest.startRecordNumber = 0;
    this.service.vehicleListRequest.licensePlate = '';
    this.service.vehicleListRequest.companyMakeName = null;
    this.service.vehicleListRequest.registrationDate = '';
    this.service.vehicleListRequest.color = '';
    this.service.vehicleListRequest.year = null;
    this.service.vehicleListRequest.chassisNo = '';
    this.service.vehicleListRequest.fuelType = null;
    this.service.vehicleListRequest.sourceOfCreation = null;
    this.service.vehicleListRequest.vehicleType = null;
    this.service.vehicleListRequest.vehicleGroup = null;
    this.service.vehicleListRequest.transmission = null;
  }
  onClose() {
    this.isAdvanceSearch = false;
  }
  onSearch() {
    if (this.vehicleStatusList.length == 0) {
      this.GetAllVehicleStatus();
    }
    if (this.vehicleTypes.length == 0) {
      this.GetAllVehicleTypes();
    }
    if (this.makeList.length == 0) {
      this.GetAllMake();
    }
    if (this.applicationSourceList.length == 0) {
      this.GetApplicationSource();
    }
    if (this.fuels.length == 0) {
      this.GetAllFuelTypes();
    }
    if (this.vehicleTransmissionList.length == 0) {
      this.GetVehicleTransmission();
    }
    this.cdr.detectChanges();
    this.isAdvanceSearch = true;
    this.cdr.detectChanges();
  }
  AdvanceSearchSubmit() {
    this.vehicleList = []
    this.service.vehicleListRequest.searchTerm = this.searchTerm;
    this.service.vehicleListRequest.startRecordNumber = Constant.startRecordNumber;
    this.service.vehicleListRequest.pageSize = this.pagerData.pagerSize <= Constant.GridPagerSize ? Constant.GridPagerSize : this.pagerData.pagerSize;
    this.getVehicleList();
    this.isAdvanceSearch = false;
  }

  empty(e: any) {
    switch (e) {
      case "":
      case null:
      case undefined:
        return true;
      default:
        return false;
    }
  }

  SyncChange(status: any) {
    if (status == undefined) {
      this.service.vehicleListRequest.syncId = Enums.DmsSync.All;
    } else {
      this.service.vehicleListRequest.syncId = status;
    }
    this.vehicleList = [];
    this.service.vehicleListRequest.startRecordNumber = 0;
    this.getVehicleList();
  }

  onScrollDown(_ev: any) {
    if(this.totalCount > this.vehicleList.length){
      this.service.vehicleListRequest.startRecordNumber = this.vehicleList.length;
      this.getVehicleList();
    }

  }

  async getVehicleList() {
    this.spinner.show();
    this.service.vehicleListRequest.chassisNo = !this.empty(this.service.vehicleListRequest.chassisNo) ? this.service.vehicleListRequest.chassisNo : null;
    this.service.vehicleListRequest.color = !this.empty(this.service.vehicleListRequest.color) ? this.service.vehicleListRequest.color : null;
    this.service.vehicleListRequest.sourceOfCreation = !this.empty(this.service.vehicleListRequest.sourceOfCreation) ? this.service.vehicleListRequest.sourceOfCreation : null;
    this.service.vehicleListRequest.companyMakeName = !this.empty(this.service.vehicleListRequest.companyMakeName) ? this.service.vehicleListRequest.companyMakeName : null;
    this.service.vehicleListRequest.fuelType = !this.empty(this.service.vehicleListRequest.fuelType) ? this.service.vehicleListRequest.fuelType : null;
    this.service.vehicleListRequest.licensePlate = !this.empty(this.service.vehicleListRequest.licensePlate) ? this.service.vehicleListRequest.licensePlate : null;
    this.service.vehicleListRequest.transmission = !this.empty(this.service.vehicleListRequest.transmission) ? this.service.vehicleListRequest.transmission : null;
    this.service.vehicleListRequest.vehicleGroup = !this.empty(this.service.vehicleListRequest.vehicleGroup) ? this.service.vehicleListRequest.vehicleGroup : null;
    this.service.vehicleListRequest.vehicleType = !this.empty(this.service.vehicleListRequest.vehicleType) ? this.service.vehicleListRequest.vehicleType : null;
    this.service.vehicleListRequest.year = !this.empty(this.service.vehicleListRequest.year) ? this.service.vehicleListRequest.year : 0;
    this.service.vehicleListRequest.syncId = !this.empty(this.service.vehicleListRequest.syncId) ? this.service.vehicleListRequest.syncId : 0;
    const temp = new Date();
    if (!this.empty(this.service.vehicleListRequest.registrationDate)) {
      let registerdate = new Date(Utility.getDateStringToDate(this.service.vehicleListRequest.registrationDate).getTime() - (temp.getTimezoneOffset() * 60000));
      this.service.vehicleListRequest.registrationDate = registerdate.toLocaleDateString();
    } else {
      this.service.vehicleListRequest.registrationDate = "";
    }
    await this.service.getVehicleList(this.service.vehicleListRequest).then((response) => {
      this.spinner.hide();
      this.vehicleList.push(...this.VehicleDataMapper(response.vehicleLists));
      if (response.result?.errorCode == "4004") {
        this.totalCount = 0;
      }
      else {
        this.totalCount = this.vehicleList.length > 0 ? this.vehicleList[0].totalCount : 0;
      }
      this.resetPagerData(this.supplierInitiliseGridFromServer(this.vehicleList, this.totalCount));
      if (this.pagerData.page > 1) {
        this.resetPagerData(this.initilisePagerFromServer(this.pagerData.page, this.pagerData.pagerSize, this.totalCount));
      }

    },_error => {
      this.spinner.hide();
    });   
  }
  async setPage(pagerData: PagerData) {
    if (
      pagerData == null ||
      pagerData === undefined ||
      pagerData.page < 1 ||
      pagerData.page > this.pager.totalPages
    ) {
      return;
    }
    this.pagerData.page = pagerData.page;
    this.pagerData.pagerSize = pagerData.pagerSize;
    this.service.vehicleListRequest.startRecordNumber =
      pagerData.pagerSize * (pagerData.page - 1);
    this.service.vehicleListRequest.pageSize = pagerData.pagerSize;
    await this.getVehicleList();
  }
  @HostListener('document:click', ['$event'])
  onSearchBoxClose(event) {
    if (event && (event.target.className.indexOf('ng-option')==-1 && event.target.parentElement.className.indexOf('ng-option') == -1 &&event.target.className.indexOf('btn')==-1)) {
      if (!this._eref.nativeElement.getElementsByClassName('advanced-search-box')[0]?.contains(event.target)) {       
        this.isAdvanceSearch = false;             
      }
    }
  }
  resetPagerData(pageData: any) {
    this.pager = pageData.pager;
    this.pagedItems = pageData.pagedItems;
    pageData.recordSize = this.totalCount;
  }
  supplierInitiliseGridFromServer(data: any[], count: number) {
    if (data != null && data !== undefined) {
      this.dataRows = data;
      return this.refreshGridFromServer(data, count);
    }
    return this.refreshGridFromServer([], 0);
  }

  refreshGridFromServer(data: any[], count: number) {
    this.filterItems = data;
    this.filter.page = data.length === 0 ? 0 : 1;
    return this.initilisePagerFromServer(
      this.filter.page,
      Number(this.filter.pageSize),
      count
    );
  }

  initilisePagerFromServer(
    page: number,
    _pageSize: number,
    count: number = this.filterItems.length
  ) {
    let length =
      this.filterItems.length <= Constant.GridPagerSize
        ? Constant.GridPagerSize
        : this.pagerData.pagerSize;
    this.filter.pageSize = length;
    this.pager = this.pagerService.getPager(count, page, length);
    this.pagedItems = this.filterItems; // .slice(this.pager.startIndex, this.pager.endIndex + 1);
    return { pager: this.pager, pagedItems: this.pagedItems };
  }

  private VehicleDataMapper(service: VehicleListViewModel[]) {
    let supperArray = [];
    if (service && service.length > 0) {
      for (let index = 0; index < service.length; index++) {
        const element = service[index];

        const single = Object();
        single.rowNumber =
          this.service.vehicleListRequest.startRecordNumber + 1 + index;
        single.id = element.id;
        single.vehicleId = element.vehicleId;
        single.licensePlate = element.licensePlate;
        single.engineSerialNo = element.engineSerialNo;
        single.companyMakeCode = element.companyMakeCode;
        single.companyModel = element.companyModel;
        single.companyMakeName = element.companyMakeName;
        single.mchCode = element.mchCode;
        single.registrationDate = element.registrationDate;
        single.color = element.color;
        single.year = element.year;
        single.chassisNo = element.chassisNo;
        single.fuelType = element.fuelType;
        single.vehicleGroup = element.vehicleGroup;
        single.vehicleType = element.vehicleType;
        single.dmsSyncStatus = element.dmsSyncStatus;
        single.dmsSyncDate = element.dmsSyncDate ? new Date(element.dmsSyncDate + 'Z') : null;
        single.logo = element.companyMakeCode
          ? this.getBrandImage(element.companyMakeCode)
          : null;
        element.sourceOfCreation = element.sourceOfCreation == "Admin" ? "Planner" : element.sourceOfCreation;
        single.sourceOfCreation = element.sourceOfCreation
          ? element.sourceOfCreation
          : '';
        single.vehicleType = element.vehicleType;
        single.totalCount = element.totalCount
        supperArray.push(single);
      }
    }

    return supperArray;
  }
  public getBrands(): Promise<void> {
    return new Promise((resolve, _reject) => {
      this.brandService.getBrand().then((res) => {
        if (res) {
          this.brandList = res;
        }
        resolve()
      });
    })
  }

  getBrandImage(key: any) {
    return this.brandList?.filter(
      (x) => x.brandCode.toUpperCase() === key.toUpperCase()
    )[0];
  }
  editVehicleDetails(vehicle: any) {
    this.service.vehicleId = vehicle.vehicleId;
    this.service.licensePlate = vehicle.licensePlate;
    this.service.make = vehicle.companyMakeCode;
    this.service.model = vehicle.companyModel;
    this.service.vinNo= vehicle.chassisNo;
    this.service.vehicleGuid= vehicle.id;
    const modalref = this.modalService.open(EditVehicleComponent, {
      size: 'lg',
      windowClass: 'EditPopup',
    });
    modalref.componentInstance.fromHistory = false;
    modalref.componentInstance.fromWorkOrder = false;
    modalref.result.then(
      (response) => {
        if(response.appointmentDetails){
          this.onEdit(response.appointmentDetails, response.isEditable);
        }
        else if (response.success) {
          this.ngOnInit();
        }
      },
    );
  }

  private getDismissDeleteReason(reason: any): boolean {
    if (reason === ModalDismissReasons.ESC) {
      return false;
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return false;
    } else {
      return reason;
    }
  }
  onSyncToDms(licensePlate) {
    let modelHeadermsg = this.translate.instant(this.isMG ? "lblSyncToCRM" : "lblSyncToDMS");
    let modelBodymsg = this.translate.instant(this.isMG ? "lblSureToSyncCRM" : "lblSureToSync");
    let errorMsg = this.translate.instant('lblErrormsg');
    const modalRef = this.modalService.open(NgbdModalContent);
    modalRef.componentInstance.modelHeader = modelHeadermsg;
    modalRef.componentInstance.modelBody = modelBodymsg;
    modalRef.result.then((_result) => { 
      // This is intentional
    }, (reason) => {
      this.popupCloseResult = this.getDismissDeleteReason(reason);
      if (this.popupCloseResult) {
        this.spinner.show();
        this.service.ResyncVehicle(licensePlate, Enums.ModuleNames.Vehicle).then((response) => {
          this.spinner.hide();
          if (response.responseObject.isSuccess) {
            let successMsg = this.translate.instant(this.isMG ? 'lblSyncSuccessCRM' : 'lblSyncSuccess')
            this.toaster.success(successMsg);
            this.vehicleList = [];
            this.service.vehicleListRequest.startRecordNumber = 0;
            this.getVehicleList();
          } else {
            this.spinner.hide();
            this.toaster.error(errorMsg);
          }
        });
      }
    });
  }
  viewException(id: number) {
    this.dmsLogRequestModel.referenceId = id;
    this.spinner.show();
    let errorMsg = this.translate.instant('lblNoErrorDetails');
    this.dmsService.GetDmsSyncFailedLog(this.dmsLogRequestModel).then((response) => {
      if (response.responseCode == Constant.SuccessResponseCode) {
        this.spinner.hide();
        if (response.responseObject.length > 0) {
          let ex = response.responseObject[0].exceptionMessage;

          let modelHeadermsg = this.translate.instant("lblException");
          const modalRef = this.modalService.open(NgInfoModalContent);
          modalRef.componentInstance.modelHeader = modelHeadermsg;
          modalRef.componentInstance.modelBody = ex;
          modalRef.result.then((_result) => {
            // This is intentional
           }, (reason) => {
            this.popupCloseResult = this.getDismissDeleteReason(reason);
          });
        } else {
          this.toaster.error(errorMsg);
        }
      }
      else if (response.responseObject && response.responseObject.errorCount > 0) {
        if (response.responseObject.result &&
          response.responseObject.result.errorCode === Enums.ErrorCodes.MechanicCode) {
          this.spinner.hide();
        }
      }
      this.spinner.hide();
    });
  }

  vehicleHistory(licensePlate: string) {
    this.service.licensePlate = licensePlate;
    this.editAppointmentService.isFromVehicleHistoricalTab = true;
    const modalref = this.modalService.open(EditVehicleComponent, {
      size: 'lg',
      windowClass: 'EditPopup',
    });
    modalref.componentInstance.fromHistory = true;
    modalref.result.then(
      (response) => {
        if (response.success) {
          this.ngOnInit();
        }
      },
      (_error) => { 
        // This is intentional
      }
    );
  }
  onEdit(appointment: any, isEdit: boolean) {
    this.multiStackPopupService.OpenAppointment(appointment.id);
  }

  OpenSaveSearchModal(content) {
    this.saveSearchFilter.saveSearchArray = [];
    this.control = new FormControl();
    this.createSaveSearchModel();
    if (this.saveSearchFilter.saveSearchArray.length > 0) {
      this.modalService.open(content, { size: 'xl', ariaLabelledBy: 'modal-basic-title' }).result.then((result) => {
        this.closeResult = `Closed with: ${result}`;
      }, (reason) => {
        this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      });
    }
    else {
      let ErrorMsg = this.translate.instant("lblPleaseFillAtleastOneField");
      this.toaster.error(ErrorMsg);
    }
  }

  createSaveSearchModel() {
    this.saveSearchFilter.filterName = null;

    if (this.service.vehicleListRequest.licensePlate) {
      let searchModel: SearchArrayModel =
      {
        searchColumnName: "lblRegistrationNumber",
        searchValue: this.service.vehicleListRequest.licensePlate,
        searchActualValue: this.service.vehicleListRequest.licensePlate
      }
      this.saveSearchFilter.saveSearchArray.push(searchModel);
    }
    if (this.service.vehicleListRequest.companyMakeName) {
      let searchModel: SearchArrayModel =
      {
        searchColumnName: "lblMake",
        searchValue: this.service.vehicleListRequest.companyMakeName,
        searchActualValue: this.service.vehicleListRequest.companyMakeName
      }
      this.saveSearchFilter.saveSearchArray.push(searchModel);
    }
    if (this.service.vehicleListRequest.registrationDate) {
      let searchModel: SearchArrayModel =
      {
        searchColumnName: "lblRegistrationFirstDate",
        searchValue: this.service.vehicleListRequest.registrationDate,
        searchActualValue: this.service.vehicleListRequest.registrationDate
      }
      this.saveSearchFilter.saveSearchArray.push(searchModel);
    }
    if (this.service.vehicleListRequest.color) {
      let searchModel: SearchArrayModel =
      {
        searchColumnName: "lblColor",
        searchValue: this.service.vehicleListRequest.color,
        searchActualValue: this.service.vehicleListRequest.color
      }
      this.saveSearchFilter.saveSearchArray.push(searchModel);
    }
    if (this.service.vehicleListRequest.year > 0) {
      let searchModel: SearchArrayModel =
      {
        searchColumnName: "lblYear",
        searchValue: this.service.vehicleListRequest.year.toString(),
        searchActualValue: this.service.vehicleListRequest.year.toString()
      }
      this.saveSearchFilter.saveSearchArray.push(searchModel);
    }
    if (this.service.vehicleListRequest.chassisNo) {
      let searchModel: SearchArrayModel =
      {
        searchColumnName: "lblVinNumber",
        searchValue: this.service.vehicleListRequest.chassisNo,
        searchActualValue: this.service.vehicleListRequest.chassisNo
      }
      this.saveSearchFilter.saveSearchArray.push(searchModel);
    }
    if (this.service.vehicleListRequest.fuelType) {
      let searchModel: SearchArrayModel =
      {
        searchColumnName: "lblFuelType",
        searchValue: this.service.vehicleListRequest.fuelType,
        searchActualValue: this.service.vehicleListRequest.fuelType
      }
      this.saveSearchFilter.saveSearchArray.push(searchModel);
    }
    if (this.service.vehicleListRequest.sourceOfCreation) {
      let searchModel: SearchArrayModel =
      {
        searchColumnName: "lblSource",
        searchValue: this.service.vehicleListRequest.sourceOfCreation,
        searchActualValue: this.service.vehicleListRequest.sourceOfCreation
      }
      this.saveSearchFilter.saveSearchArray.push(searchModel);
    }
    if (this.service.vehicleListRequest.vehicleType) {
      let searchModel: SearchArrayModel =
      {
        searchColumnName: "lblVehicalType",
        searchValue: this.service.vehicleListRequest.vehicleType,
        searchActualValue: this.service.vehicleListRequest.vehicleType
      }
      this.saveSearchFilter.saveSearchArray.push(searchModel);
    }
    if (this.service.vehicleListRequest.vehicleGroup) {
      let searchModel: SearchArrayModel =
      {
        searchColumnName: "lblVehicleStatus",
        searchValue: this.service.vehicleListRequest.vehicleGroup,
        searchActualValue: this.service.vehicleListRequest.vehicleGroup
      }
      this.saveSearchFilter.saveSearchArray.push(searchModel);
    }
    if (this.service.vehicleListRequest.transmission) {
      let searchModel: SearchArrayModel =
      {
        searchColumnName: "lblTransmission",
        searchValue: this.service.vehicleListRequest.transmission,
        searchActualValue: this.service.vehicleListRequest.transmission
      }
      this.saveSearchFilter.saveSearchArray.push(searchModel);
    }
  }

  SaveAdvanceSearchFilter() {
    if (!this.saveSearchFilter.filterName.replace(/\s/g, "").length) {
      let errorMsg = this.translate.instant("lblSearchNameRequired");
      this.toaster.error(errorMsg);
      return;
    }
    this.advanceSearchService.SaveAdvanceSearchFilter(this.saveSearchFilter).then((response) => {
      if (response.responseCode == Constant.SuccessResponseCode && response.responseObject === true) {
        let successMsg = this.translate.instant("lblSearchFilteredSaved");
        this.toaster.success(successMsg);
        this.modalService.dismissAll();
      }
      else {
        let errorMsg = this.translate.instant("lblSaveSearchFilterNameAlreadyExists");
        this.toaster.error(errorMsg);
      }
    });
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }

  OpenSavedSearchListPopup() {
    this.spinner.show();
    this.GetAdvanceSearchList().then((_res) => {
      const modalRef = this.modalService.open(SavedSearchComponent, {
        size: 'xl',
        ariaLabelledBy: 'modal-basic-title',
      });
      modalRef.componentInstance.isFromAppointment = false;
      modalRef.componentInstance.searchList = this.savedSearchListResponse;
      modalRef.componentInstance.onReset.subscribe((_data) => {
        this.onReset();
      });
      modalRef.componentInstance.onEditOrRun.subscribe((data) => {
        if (data.isRun) {
          this.resetVariables();
        }
        this.ApplySaveSearch(data.searchData, data.isRun);
      });
      modalRef.componentInstance.onDelete.subscribe((data) => {
        this.OnDeleteSaveSearch(data,modalRef);
      });
    });
  }

  async GetAdvanceSearchList() {
    await this.advanceSearchService.GetAdvanceSearchList(Enums.ModuleNames.Vehicle).then(result => {
      if (result) {
        if (result.responseObject.errorCount) {
          this.spinner.hide();
        }
        else {
          this.savedSearchListResponse = result.responseObject;
          this.savedSearchListResponse.forEach(element => {
            element.saveSearchArray.forEach(val => {
              val.searchActualValue = val.searchValue;
            });
          });
        }
      }
      this.spinner.hide();
    },
      _error => {
        this.spinner.hide()
      });
  }

  OnDeleteSaveSearch(searchName,outerModalRef) {
    let modelHeadermsg = this.translate.instant("lblDelete");
    let modelBodymsg = Utility.createMessage(this.translate.instant("lblSureToDelete"), this.translate.instant("lblSavedFilters"), true);
    const modalRef = this.modalService.open(NgbdModalContent);
    modalRef.componentInstance.modelHeader = modelHeadermsg;
    modalRef.componentInstance.modelBody = modelBodymsg;
    modalRef.result.then((_result) => { 
      // This is intentional
    }, (reason) => {
      this.popupCloseResult = this.getDismissDeleteReason(reason);
      if (this.popupCloseResult) {
        this.deleteSearchFilter.filterName = searchName;
        this.advanceSearchService.DeleteAdvanceSearch(this.deleteSearchFilter).then(response => {
          if (response.responseCode == Constant.SuccessResponseCode && response.responseObject === true) {
            this.GetAdvanceSearchList().then(()=>outerModalRef.dismiss());
            let msg = this.translate.instant("lblSaveSearchDeletedSuccessfully");
            this.toaster.success(msg);
          }
          else {
            let msg = this.translate.instant("lblFailedTodeleteSaveSearch");
            this.toaster.error(msg);
          }
        }, error => {
          if (error.status === Constant.BadRequest) {
            let WarningMessage = this.translate.instant("lblErrorWarningForValue")
            this.toaster.warning(WarningMessage);
          }
          else {
            let errorMessage = this.translate.instant("lblErrorMessage");
            this.toaster.error(errorMessage);
          }

        });
      }
    });
  }

  ApplySaveSearch(data,isRunSearch) {
    if (data) {
      let saveSearchDetail = this.savedSearchListResponse.filter(x => x.filterName === data);
      if (saveSearchDetail.length > 0 && saveSearchDetail[0]) {
        saveSearchDetail[0].saveSearchArray.forEach(element => {
          switch (element.searchColumnName) {
            case 'lblRegistrationNumber':
              this.service.vehicleListRequest.licensePlate = element.searchValue;
              break;
            case 'lblVehicleStatus':
              this.service.vehicleListRequest.vehicleGroup = element.searchValue;
              break;
            case 'lblVehicalType':
              this.service.vehicleListRequest.vehicleType = element.searchValue;
              break;
            case 'lblMake':
              this.service.vehicleListRequest.companyMakeName = element.searchValue;
              break;
            case 'lblVinNumber':
              this.service.vehicleListRequest.chassisNo = element.searchValue;
              break;
            case 'lblRegistrationFirstDate':
              this.service.vehicleListRequest.registrationDate = element.searchValue;
              break;
            case 'lblSource':
              this.service.vehicleListRequest.sourceOfCreation = element.searchValue;
              break;
            case 'lblColor':
              this.service.vehicleListRequest.color = element.searchValue;
              break;
            case 'lblFuelType':
              this.service.vehicleListRequest.fuelType = element.searchValue;
              break;
            case 'lblTransmission':
              this.service.vehicleListRequest.transmission = element.searchValue;
              break;
            case 'lblYear':
              this.service.vehicleListRequest.year = parseInt(element.searchValue);
              break;
            default:
              break;
          }
        });
      }
      if (isRunSearch) {
        if (this.service.vehicleListRequest.registrationDate) {
          this.service.vehicleListRequest.registrationDate = this.service.vehicleListRequest.registrationDate.replace(/\//g, ".");
        }
        this.AdvanceSearchSubmit();
      }
      else {
        this.onSearch();
        this.activeModal.dismiss();
      }
    }
  }

  deleteVehicle(vhcle)
  {
    let modelHeadermsg = this.translate.instant("lblDelete");
    let modelBodymsg = Utility.createMessage(this.translate.instant("lblSureToDelete"), this.translate.instant("lblPdfVehicle"), false);
    const modalRef = this.modalService.open(NgbdModalContent);
    modalRef.componentInstance.modelHeader = modelHeadermsg;
    modalRef.componentInstance.modelBody = modelBodymsg;
    modalRef.result.then((_result) => { 
      // This is intentional
    }, (reason) => {
      this.popupCloseResult = this.getDismissDeleteReason(reason);
      if (this.popupCloseResult) {
        this.spinner.show();
        let deleteRequestModel = { 
          VehicleId: vhcle.vehicleId
          ,ModuleId:0
          ,LicensePlate: vhcle.licensePlate
          ,ChassisNo: vhcle.chassisNo
          ,IntegrationWithDms: this.integrationWithDMS
          ,CreatedBy: '' 
        };

        this.service.DeleteVehicle(deleteRequestModel).then((response) => {
          this.spinner.hide();
          if (response.responseCode == Constant.SuccessResponseCode) {
            if(response.responseObject){
              let deletedmsg = this.translate.instant("lblVehicleUpdateDeleted");
              this.toaster.success(deletedmsg);
              this.ngOnInit();
            }else{
              let deletedmsg = this.translate.instant("lblVehicleAssociateAppointment");
                this.toaster.error(deletedmsg);
            }
          }else{
            let deletedmsg = this.translate.instant("lblVehicleAssociateAppointment");
            this.toaster.error(deletedmsg);
          }
        },
        _error => {
          this.spinner.hide()
        });
      }
    });
  }

  async getFeatures() {
    let features = this.secureStorage.getKeyData('feature');
    if (features == null || features == undefined) {
      this.subscription = this.currentLanguageService.featureList.subscribe((res) => {
        features = res;
        if (features?.length > 0) {
          this.integrationWithDMS = this._clientName === 'mg' ? features.find(x => x.featureCode === Enums.FeatureCode.CRM)?.isActive : 
          features.find(x => x.featureCode === Enums.FeatureCode.DMS)?.isActive;
        }
      })
    } else {
      this.integrationWithDMS = this._clientName === 'mg' ? features.find(x => x.featureCode === Enums.FeatureCode.CRM)?.isActive : 
      features.find(x => x.featureCode === Enums.FeatureCode.DMS)?.isActive;
    }
  }

}
